<template>
  <v-dialog
    v-model="dialogDemo"
    transition="dialog-bottom-transition"
    width="400"
  >
    <v-card>
      <v-card-title class="headline text-center">
        Файл прошёл регистрацию в AvisHASH
      </v-card-title>
      <v-card-text style="color: red;" class="text-center mt-4">
        <p>
          Демонстрационный режим.
        </p>
        <p>
          Зарегистрированный цифровой отпечаток файла будет удалён через 1 сутки.
        </p>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
          color="indigo darken-1"
          @click="continueRegistration"
          dark
          width="100"
        >
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'DemoRegistration',
  props: {
    dialogDemo: {
      type: Boolean,
      default: false,
    },
    orderNumber: {
      type: String,
      required: true,
    }
  },

  methods: {
    continueRegistration() {
      this.$router.push({name: 'RegResult', params: { id: this.orderNumber }})
      this.isLoading = false
    },
  },
}
</script>